import React, { useEffect, useState } from 'react'
import { rolesService } from '../../../../_services/roles.service'

export default function RoleDetails({ role }) {
  const [roleDetails, setRoleDetails] = useState(null)
  
  useEffect(() => {
    if (role) {
      rolesService.retrieveRole(role.id)
      .then(response => {
        const details = response.data.data
        const permissions = {}
        details.permissions.forEach(permission => {
          const name = permission.name.split('-')[0]
          if (permissions[name]) {
            permissions[name].push(permission.title)
          } else {
            permissions[name] = [permission.title]
          }
        })
        setRoleDetails({...details, permissions})
      })
    }
  }, [role])

  if (!roleDetails) {
    return null
  }

  return (<div>
    <div className='mb-4 font-weight-normal'>
      <p className='mb-3'><strong>Name:</strong> { roleDetails.name }</p>
      <p className='text-muted'><strong>Description:</strong> { roleDetails.title }</p>
    </div>

    <h6>Permissions:</h6>
    <hr />
    { Object.keys(roleDetails.permissions).map((name, index) => {
      return <div key={index} style={{fontSize: '14px'}}>
        <span className='text-capitalize'>{ name }</span>
        <ul className='mt-2'>
          {roleDetails.permissions[name].map((value, index) => {
            return <li key={index} className='mb-1 list-unstyled'>
              <i className="fas fa-circle fa-xs text-primary pr-1"></i>&nbsp;{ value }
            </li>
          })}
        </ul>
      </div>
    })}
  </div>
  )
}
